export enum ErrorSerial {
    /**
     * general or unknown errors
     */
    GENERAL = "1000",

    TERMS_APPROVAL = "1001",

    TERMS_RETRIEVAL = "1002",
}
